import { newE2EPage } from "@stencil/core/testing";

async function setupPage(attrs = "") {
    const page = await newE2EPage({
        html: `
            <uic-thumbnail ${attrs}>
                <uic-thumbnail-item id="1"></uic-thumbnail-item>
                <uic-thumbnail-item id="2"></uic-thumbnail-item>
                <uic-thumbnail-item id="3"></uic-thumbnail-item>
            </uic-thumbnail>`
    });
    const element = await page.find("uic-thumbnail");

    return { page, element };
}

describe("uic-thumbnail", () => {
    it("renders default", async () => {
        const { element } = await setupPage();
        expect(element).toMatchSnapshot();
    });

    it("renders controls when scrollable", async () => {
        const { element, page } = await setupPage(`style="height: 60px"`);
        expect(element).toMatchSnapshot();

        const [moveUpButton, moveDownButton] = await page.findAll(`uic-thumbnail >>> uic-icon-button`);

        expect(await moveUpButton.getProperty("disabled")).toBe(true);
        expect(await moveDownButton.getProperty("disabled")).toBe(false);

        // move to bottom
        const item3 = await page.find('[id="3"]');
        await item3.focus();

        await moveDownButton.click();
        await moveDownButton.click();

        // make absolutely sure smooth scrolling animations are done
        await new Promise((r) => setTimeout(r, 1000));

        expect(await moveUpButton.getProperty("disabled")).toBe(false);
        expect(await moveDownButton.getProperty("disabled")).toBe(true);
    });

    describe("selected index", () => {
        it("should select first item when selected is undefined", async () => {
            const { element, page } = await setupPage();
            const item1 = await page.find('[id="1"]');
            expect(await item1.getProperty("selected")).toBe(true);
            expect(await element.getProperty("selected")).toBe(0);
        });
        it("should select the item specified by selected index", async () => {
            const { element, page } = await setupPage(`selected="2"`);
            const item3 = await page.find('[id="3"]');
            expect(await item3.getProperty("selected")).toBe(true);
            expect(await element.getProperty("selected")).toBe(2);
        });
        it("should select item with click", async () => {
            const { page } = await setupPage();
            const uicSelect = await page.spyOnEvent("uicSelect");

            const item2 = await page.find('[id="2"]');
            await item2.click();

            expect(uicSelect).toHaveReceivedEventDetail(1);
        });
    });

    describe("keyboard", () => {
        it("arrow navigation", async () => {
            const { page, element } = await setupPage();

            const item2 = await page.find('[id="2"]');
            await item2.focus();

            page.keyboard.press("ArrowDown");

            await page.waitForChanges();

            page.keyboard.press(" ");

            await page.waitForChanges();

            expect(await element.getProperty("selected")).toBe(2);
        });
    });
});
